import moment from 'moment'

export const DASHBOARD_TABS = ['total', 'cold', 'hot', 'power', 'gas', 'heat']
export const DASHBOARD_PERIODS = ['hour', 'day', 'month', 'year']

function queryValue (value) {
    if (Array.isArray(value)) {
        return value[0]
    }
    return value
}

export function parseDashboardTab (tab) {
    const value = queryValue(tab)
    return DASHBOARD_TABS.indexOf(value) > -1 ? value : 'total'
}

export function parseDashboardPeriod (period, fallback = 'day') {
    const value = queryValue(period)
    return DASHBOARD_PERIODS.indexOf(value) > -1 ? value : fallback
}

export function isValidDashboardDate (date, period) {
    if (typeof date !== 'string' || !date) {
        return false
    }
    const dots = (date.match(/\./g) || []).length
    const dashes = (date.match(/-/g) || []).length
    switch (period) {
    case 'hour':
        return dots === 2 && dashes === 1
    case 'day':
        return dots === 2 && dashes === 0
    case 'month':
        return dots === 1
    case 'year':
        return dots === 0
    default:
        return false
    }
}

export function defaultDashboardDate (period = 'day', now = null) {
    const m = now || moment()
    switch (period) {
    case 'hour':
        return m.format('DD.MM.YYYY') + '-' + m.get('hour')
    case 'month':
        return m.format('MM.YYYY')
    case 'year':
        return m.format('YYYY')
    default:
        return m.format('DD.MM.YYYY')
    }
}

export function parseDashboardQuery (query = {}, defaults = {}) {
    const tab = parseDashboardTab(query.tab)
    const period = parseDashboardPeriod(query.period, defaults.period || 'day')
    const dateValue = queryValue(query.date)
    const date = isValidDashboardDate(dateValue, period)
        ? dateValue
        : (defaults.date || defaultDashboardDate(period))
    return { tab, period, date }
}

export function dashboardQueryChanged (current = {}, next = {}) {
    return ['tab', 'period', 'date'].some((key) => {
        return String(queryValue(current[key]) || '') !== String(queryValue(next[key]) || '')
    })
}

export function tabIndex (tab) {
    const index = DASHBOARD_TABS.indexOf(parseDashboardTab(tab))
    return index < 0 ? 0 : index
}

export function unitForTab (type) {
    return type === 'power' ? 'watts' : 'liters'
}

export function headUnitForTab (type) {
    if (type === 'power') {
        return 'watts'
    }
    if (type === 'heat') {
        return 'heat_units'
    }
    return 'liters'
}
